module.exports = __webpack_public_path__ + "img/visa.fdbd5726.svg";